import React, { useState } from "react";
import { Stack } from "react-bootstrap";
import { useAtomValue } from "jotai";
import { useTranslation } from "react-i18next";

import "./EditProfilePage.scss";
import PrimaryActionButton from "../../components/Buttons/PrimaryActionButton/PrimaryActionButton";
import { CustomSpinner } from "../../components/CustomSpinner/CustomSpinner";
import AvatarSection from "../../components/create-username-page/AvatarSection/AvatarSection";
import { userProfileAtom } from "../../jotai/atoms/user";
import HeaderWithTitleAndBackButton from "../../components/Headers/HeaderWithTitleAndBackButton/HeaderWithTitleAndBackButton";
import UsernameInput, {
  UsernameUpdateOrigin,
} from "../../components/create-username-page/UsernameInput/UsernameInput";

function EditProfilePage() {
  const { t } = useTranslation("common", { keyPrefix: "profile" });
  const [isLoading, setIsLoading] = useState(false);
  const userProfile = useAtomValue(userProfileAtom);
  const [username, setUsername] = useState(userProfile?.username ?? "");
  const isUsernameUnchanged =
    userProfile?.username && userProfile.username === username;

  return (
    <div className="d-flex flex-column edit-username-page justify-content-between">
      <HeaderWithTitleAndBackButton
        title={{ text: t("edit_profile") }}
        goToPreviousPage
      />
      <Stack
        gap={3}
        className="justify-content-center align-items-center edit-username-content"
      >
        <AvatarSection />
        <UsernameInput
          username={username}
          setUsername={setUsername}
          setIsLoading={setIsLoading}
          origin={UsernameUpdateOrigin.EDIT_PROFILE}
        />
      </Stack>
      <PrimaryActionButton
        type="submit"
        form="username-form"
        size="lg"
        text={
          <>
            {isLoading && <CustomSpinner size="sm" />}
            {t("save_changes")}
          </>
        }
        disabled={isLoading || !username || !!isUsernameUnchanged}
      />
    </div>
  );
}

export default EditProfilePage;
